import { DatePipe, JsonPipe } from '@angular/common';
import { Component, Input, OnInit, WritableSignal, computed, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConfirmationDialogComponent } from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { AgeStringPipe } from '../../../../pipes/age-string.pipe';
import { AssessmentNotesPipe } from '../../../../pipes/assessment-notes.pipe';
import { AssessmentScorePipe } from '../../../../pipes/assessment-score.pipe';
import { GenderStringPipe } from '../../../../pipes/gender-string.pipe';
import { MonthStringPipe } from '../../../../pipes/month-string.pipe';
import { AssessmentsService } from '../../../../services/assessments.service';
import { Assessment, AssessmentType, CustomAssessment, Patient } from '../../../../services/model';
import { AssessmentScorePercentPipe } from '../../../../pipes/assessment-score-percent.pipe';

@Component({
  selector: 'app-assessment-table-sub',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    JsonPipe,
    MatTableModule,
    MonthStringPipe,
    GenderStringPipe,
    AgeStringPipe,
    DatePipe,
    AssessmentNotesPipe,
    AssessmentScorePipe,
    AssessmentScorePercentPipe,
    MatIconModule,
    MatProgressBarModule,
    RouterModule,
    MatMenuModule,
    MatTabsModule,
  ],
  templateUrl: './assessment-table.component.html',
  styleUrl: './assessment-table.component.scss',
})
export class AssessmentTableComponent implements OnInit {
  @Input() assessmentList: WritableSignal<Assessment[]> | undefined;
  @Input() type?: AssessmentType;
  @Input() printMode: boolean = false;
  @Input() customAssessment?: CustomAssessment;
  assessmentFilteredList = computed(() => {
    if (this.assessmentList) {
      const result = this.assessmentList().filter(element => {
        if (this.type === 'CUSTOM' && element.type === this.type) {
          return element.customId === this.customAssessment?.id;
        } else {
          return element.type === this.type;
        }
      });
      // console.log('assessmentFilteredList', result);
      return result;
    } else {
      return [];
    }
  });

  patient: WritableSignal<Patient | undefined> = signal(undefined);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private assessmentsService: AssessmentsService = inject(AssessmentsService);

  tableColumns = ['date', 'score', 'note', 'buttons'];

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    if (
      ['ARAT', 'BBT', 'NHPT'].includes(this.type!) ||
      (this.type === 'CUSTOM' && this.customAssessment?.sideDistinction)
    ) {
      this.tableColumns = ['date', 'score_left', 'score_right', 'note', 'buttons'];
    }
    if (this.printMode) {
      this.tableColumns = this.tableColumns.filter(item => item !== 'buttons');
    }
  }

  navigateToAssessment(assessment: Assessment) {
    console.log('ass', assessment);
    if (assessment) {
      if (assessment.customId) {
        this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
          relativeTo: this.route,
          queryParams: { id: assessment.customId },
        });
      } else {
        this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
          relativeTo: this.route,
        });
      }
    }
  }

  deleteAssessment(assessment: Assessment) {
    if (assessment?._documentId) {
      this.onDelete(assessment._documentId);
    }
  }

  onDelete(assessmentId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Wirklich löschen?',
        description: 'Wollen sie die Testung wirklich löschen?',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'YES') {
        this.assessmentsService.deleteAssessment(assessmentId!).then(res => {
          // this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
          this.snackBar.open('Die Testung wurde erfolgreich gelöscht.', '', {
            duration: 3000,
          });
        });
      }
    });
  }

  search() { }
}
